import { useState } from "react";
import { ProgressStatus } from "../../hooks/attestations/config";
import { useAccount, useBalance } from "wagmi";
import { ImpactMintingSuccess, PreviewFrameHistoryPage } from "./MintYourImpactComponents";
import { AttestationChainId } from "./utils/constants";
import { MintingProcessContent } from "./components/index";
import { useAttestationFee } from "../contributors/hooks/useMintingAttestations";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MintProgressModalBody = _ref => {
  let {
    heading,
    subheading,
    children,
    isOnAction
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: `max-w-[710px] p-4 flex flex-col justify-center text-black ${!isOnAction ? "sm:p-8 items-center text-center gap-2 sm:gap-6" : "gap-8"}`,
    children: [/*#__PURE__*/_jsxs("div", {
      className: `flex flex-col gap-2 ${isOnAction ? "" : "sm:gap-6"}`,
      children: [/*#__PURE__*/_jsx("div", {
        className: `${isOnAction ? "text-3xl/[34px]" : "text-5xl/[39px]"} font-modern-era-bold`,
        children: heading
      }), /*#__PURE__*/_jsx("div", {
        className: `${isOnAction ? "text-[16px]/[26px]" : "text-[20px]/[26px]"} font-modern-era-regular`,
        children: subheading
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex flex-col justify-center items-center w-full",
      children: /*#__PURE__*/_jsx("div", {
        className: "min-w-[288px] sm:w-[600px] w-full",
        children: children
      })
    })]
  });
};

// MintProgressModalBodyThankYou component
export function MintProgressModalBodyThankYou(props) {
  const {
    handleSwitchChain,
    status,
    gasEstimation,
    isLoadingEstimation,
    notEnoughFunds,
    handleAttest,
    isLoading,
    heading,
    subheading
  } = props;
  const {
    address,
    isConnected
  } = useAccount();
  const {
    data: balance
  } = useBalance({
    chainId: AttestationChainId,
    address
  });
  const {
    data: attestationFee
  } = useAttestationFee();
  return /*#__PURE__*/_jsx(MintProgressModalBody, {
    heading: heading !== null && heading !== void 0 ? heading : "",
    subheading: subheading !== null && subheading !== void 0 ? subheading : "",
    isOnAction: true,
    children: /*#__PURE__*/_jsx(MintingProcessContent, {
      status: status,
      balance: balance === null || balance === void 0 ? void 0 : balance.value,
      notEnoughFunds: notEnoughFunds,
      isLoadingEstimation: isLoadingEstimation,
      gasEstimation: gasEstimation,
      isConnected: isConnected,
      attestationFee: attestationFee,
      handleSwitchChain: handleSwitchChain,
      handleAttest: handleAttest,
      isLoading: isLoading
    })
  });
}

// MintProgressModalBodyHistory component
export function MintProgressModalBodyHistory(props) {
  const {
    attestationFee,
    handleSwitchChain,
    status,
    gasEstimation,
    isLoadingEstimation,
    notEnoughFunds,
    handleAttest,
    toggleStartAction,
    isLoading,
    selectBackground,
    selectedColor,
    previewBackground,
    impactImageCid,
    heading,
    subheading
  } = props;
  const [attestationLink, setAttestationLink] = useState(undefined);
  const attest = async () => {
    setAttestationLink(await handleAttest());
  };
  const {
    address,
    isConnected
  } = useAccount();
  const {
    data: balance
  } = useBalance({
    chainId: AttestationChainId,
    address
  });
  const isOnAction = status !== ProgressStatus.SELECTING_COLOR && status !== ProgressStatus.IS_SUCCESS;
  return /*#__PURE__*/_jsx(MintProgressModalBody, {
    heading: heading !== null && heading !== void 0 ? heading : "",
    subheading: subheading !== null && subheading !== void 0 ? subheading : "",
    isOnAction: isOnAction,
    children: status === ProgressStatus.SELECTING_COLOR ? /*#__PURE__*/_jsx(PreviewFrameHistoryPage, {
      selectBackground: selectBackground,
      nextStep: () => {
        toggleStartAction === null || toggleStartAction === void 0 || toggleStartAction();
      },
      previewBackground: previewBackground,
      selectedColor: selectedColor
    }) : status === ProgressStatus.IS_SUCCESS ? /*#__PURE__*/_jsx(ImpactMintingSuccess, {
      impactImageCid: impactImageCid,
      attestationLink: attestationLink !== null && attestationLink !== void 0 ? attestationLink : "",
      isShareButtonsAbove: false
      // imageSize="size-[288px] sm:size-[400px]"
    }) : /*#__PURE__*/_jsx(MintingProcessContent, {
      status: status,
      balance: balance === null || balance === void 0 ? void 0 : balance.value,
      notEnoughFunds: notEnoughFunds,
      isLoadingEstimation: isLoadingEstimation,
      gasEstimation: gasEstimation,
      isConnected: isConnected,
      handleSwitchChain: handleSwitchChain,
      handleAttest: attest,
      isLoading: isLoading,
      attestationFee: attestationFee
    })
  });
}